// src/services/analyticsService.js
import ApiService from './api';

const analyticsService = {
  // Get Overall Financial Profitability Dashboard
  getProfitDashboard: async (params = {}) => {
    try {
      const response = await ApiService.get('/profit-calculation/dashboard', params);
      return response.data || response;
    } catch (error) {
      console.error('Failed to fetch profit dashboard analytics:', error);
      throw error;
    }
  },

  // Get Product Level Profitability & Loss Identification
  getProductProfitability: async (params = {}) => {
    try {
      const response = await ApiService.get('/profit-calculation/product-profitability', params);
      return response.data || response;
    } catch (error) {
      console.error('Failed to fetch product profitability:', error);
      throw error;
    }
  },

  // Get Recipe Variance & Potential Theft Analytics
  getRecipeVariance: async (params = {}) => {
    try {
      const response = await ApiService.get('/profit-calculation/recipe-variance', params);
      return response.data || response;
    } catch (error) {
      console.error('Failed to fetch recipe variance analytics:', error);
      throw error;
    }
  },

  // Get Demand Forecast Metrics
  getForecastMetrics: async (params = {}) => {
    try {
      const response = await ApiService.get('/profit-calculation/forecast', params);
      return response.data || response;
    } catch (error) {
      console.error('Failed to fetch forecast analytics:', error);
      throw error;
    }
  },

  // Log a new manual wastage entry (Raw Material / Product)
  createWastageEntry: async (wastageData) => {
    try {
      const response = await ApiService.post('/wastage', wastageData);
      return response.data || response;
    } catch (error) {
      console.error('Failed to log wastage entry:', error);
      throw error;
    }
  },

  // Fetch logged wastage entries
  getWastageLogs: async (params = {}) => {
    try {
      const response = await ApiService.get('/wastage', { params });
      return response.data || response;
    } catch (error) {
      console.error('Failed to fetch wastage logs:', error);
      throw error;
    }
  },

  // Fetch wastage summary stats
  getWastageSummary: async (params = {}) => {
    try {
      const response = await ApiService.get('/wastage/summary', { params });
      return response.data || response;
    } catch (error) {
      console.error('Failed to fetch wastage summary:', error);
      throw error;
    }
  },

  // Update an existing wastage entry
  updateWastageEntry: async (id, updateData) => {
    try {
      const response = await ApiService.patch(`/wastage/${id}`, updateData);
      return response.data || response;
    } catch (error) {
      console.error('Failed to update wastage entry:', error);
      throw error;
    }
  },

  // Bulk update multiple wastage entries
  bulkUpdateWastage: async (bulkData) => {
    try {
      const response = await ApiService.patch('/wastage/bulk-update', bulkData);
      return response.data || response;
    } catch (error) {
      console.error('Failed to bulk update wastage entries:', error);
      throw error;
    }
  },

  // Delete a wastage entry
  deleteWastageEntry: async (id) => {
    try {
      const response = await ApiService.delete(`/wastage/${id}`);
      return response.data || response;
    } catch (error) {
      console.error('Failed to delete wastage entry:', error);
      throw error;
    }
  },
};

export default analyticsService;
